import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { collectionPipelineStatusV3Schema } from '../pipeline-status-v3-schema';

export const getPipelineStatusV3ResponseDataSchema = z.array(collectionPipelineStatusV3Schema);

export type IGetPipelineStatusV3ResponseData = z.infer<
  typeof getPipelineStatusV3ResponseDataSchema
>;

export const getPipelineStatusV3ResponseSchema = createApiResponseSchema(
  getPipelineStatusV3ResponseDataSchema,
) as z.ZodSchema<IAPI<IGetPipelineStatusV3ResponseData>>;

export type IGetPipelineStatusV3Response = IAPI<IGetPipelineStatusV3ResponseData>;
